import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "../../app/store";
import { resetLogs, setOffset } from "./auditLogsSlice";
import { obsApi } from "api";

export const getAuditLogs = createAsyncThunk(
  "auditLog/getAuditLogs",
  async (_, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const filters = state.audit.filters;
    const query = state.audit.query;
    const startTime = state.audit.currentTime;
    return obsApi.audit
      .searchAudit({
        filters: filters,
        query: query,
        start_time: startTime,
      })
      .then((res) => {
        if (res.data !== undefined) {
          return res.data;
        }
      })
      .catch((err) => {
        return rejectWithValue(err);
      });
  },
);

export const fetchNextPage = (): AppThunk => (dispatch, getState) => {
  const state = getState() as RootState;
  const { offset, resultsPerPage } = state.audit;

  dispatch(setOffset(offset + resultsPerPage));
  dispatch(getAuditLogs());
};
export const reloadLogs = (): AppThunk => (dispatch) => {
  dispatch(setOffset(0));
  dispatch(resetLogs());
  dispatch(getAuditLogs());
};
